import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ColumnChooser from '../../../../components/ColumnChooser';
import { ColumnChooserModel } from '../../../../models/common/ColumnChooserModel';
import { GetAmbarListPagingAndFilterRequest } from '../../../../models/request/ambar/GetAmbarListPagingAndFilterRequest';
import { RootState } from '../../../../redux/store';
import { MenuComponent } from '../../../../_metronic/assets/ts/components';
import TableActions from '../../../../components/TableActions';
import ExcelExportMenu from '../../../../components/ExcelExportMenu';
import { ExcelExportMode } from '../../../../helpers/excelExportRequest';
import { GetCountryListResponseData } from '../../../../models/response/country/GetCountryListResponse';
import { GetAmbarListPagingAndFilterResponseItem } from '../../../../models/response/ambar/GetAmbarListPagingAndFilterResponse';
import TableConstantActions from '../../../../components/TableConstantActions';

interface Props {
    columns: ColumnChooserModel[]
    setColumns: React.Dispatch<React.SetStateAction<ColumnChooserModel[]>>
    getColumns: () => ColumnChooserModel[]
    pageName: string
    pageVersion: string
    excelExport: (mode: ExcelExportMode) => void
    filter: GetAmbarListPagingAndFilterRequest
    getData: (_filter?: GetAmbarListPagingAndFilterRequest | undefined) => Promise<void>
    setFilter: React.Dispatch<React.SetStateAction<GetAmbarListPagingAndFilterRequest>>
    selectedCount: number
    trCountry: GetCountryListResponseData | undefined
    saveAsDraftIrsaliye: (_sendToGib: boolean) => Promise<void>
    cancelDraftIrsaliye: () => Promise<void>
    moveToDraftIrsaliye: () => Promise<void>
    navigateToFindPrice: () => void
    items: GetAmbarListPagingAndFilterResponseItem[]
    deleteFunction: () => void
    updateFunction: () => void
    onSearchSubmit: (e: any) => void
    copyItem: () => void
}

const AmbarListFilters = ({
    columns,
    setColumns,
    getColumns,
    pageName,
    pageVersion,
    excelExport,
    filter,
    getData,
    setFilter,
    selectedCount,
    trCountry,
    saveAsDraftIrsaliye,
    cancelDraftIrsaliye,
    moveToDraftIrsaliye,
    navigateToFindPrice,
    items,
    deleteFunction,
    updateFunction,
    onSearchSubmit,
    copyItem
}: Props) => {
    const navigate = useNavigate();
    const auth = useSelector((state: RootState) => state.auth)

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)
    }, [])

    const redirectToDevice = () => {
        localStorage.setItem("FocusedVehicleId", items.find(x => x.isSelected)?.ambarVoyage?.vehicleId ?? '');
        window.open(`${window.location.origin}/map`, "_blank");
    }

    return (
        <React.Fragment>
            <TableConstantActions
                deleteFunction={deleteFunction}
                hideSearch={true}
                onSearchSubmit={onSearchSubmit}
                pageName={pageName}
                searchTerm={filter.searchTerm}
                selectedCount={selectedCount}
                setSearchTerm={(e) => setFilter({ ...filter, searchTerm: e })}
                updateFunction={updateFunction}
            />

            <TableActions
                list={[
                    { isDisabled: selectedCount == 0, text: "E-İrsaliye Taslak (Uyumsoft)", onClick: () => saveAsDraftIrsaliye(false) },
                    { isDisabled: selectedCount == 0, text: "E-İrsaliye GIB (Uyumsoft)", onClick: () => saveAsDraftIrsaliye(true) },
                    { isDisabled: selectedCount != 1 || !items.find(x => x.isSelected)?.irsaliyeStatusName, text: "E-İrsaliye Taslağa Çevir (Uyumsoft)", onClick: moveToDraftIrsaliye },
                    { isDisabled: selectedCount != 1, text: "E-İrsaliye Geri Çekme (Uyumsoft)", onClick: cancelDraftIrsaliye },
                    { isDisabled: selectedCount == 0, text: 'Toplu Fiyat Bulma', onClick: navigateToFindPrice },
                    (auth.user.user?.data.authorizedMenus?.find(x => x.menuName == "Harita") ? { isDisabled: (selectedCount != 1 || !items.find(x => x.isSelected)?.ambarVoyage?.vehicleId), text: 'Araç Takip', onClick: () => redirectToDevice() } : undefined),
                    { isDisabled: selectedCount != 1, text: "Kopyala", onClick: copyItem },
                ]}
            />

            <ColumnChooser
                columns={columns}
                getColumns={getColumns}
                pageName={pageName}
                pageVersion={pageVersion}
                setColumns={setColumns}
            />

            <ExcelExportMenu
                pageName={pageName}
                selectedCount={selectedCount}
                onExport={excelExport}
            />

            {/* Filtreler paneli kaldırıldı (22.09.2026): Sipariş/Yükleme/Sefer Başlama Tarihi, Müşteri,
                Gönderici, Alıcı, Bölüm, PO, Sefer No, Taşıma Tipi/Yöntemi, Araç/Dorse Plaka, Sürücü,
                Yükleme/Teslim İl-İlçe-Semt-Bölge kolon başlığının altındaki filtrede var. "Beklenen
                Gelir/Gider Girilmemiş" anahtarlarının karşılığı Satış/Alış Fatura Durumu kolonundaki
                "Beklenen Gelir/Gider Yok" seçeneği. */}

            <React.Fragment>
                {
                    auth.user.user?.data.authorizedMenus.find(x => x.menuName == pageName)?.canInsert && (
                        <div className='m-0'>
                            <a
                                onClick={() => navigate('/ambar/listadd')}
                                className='btn btn-sm fw-bold btn-primary'
                            >
                                Yeni Nakliye Siparişi Ekle
                            </a>
                        </div>
                    )
                }
            </React.Fragment>
        </React.Fragment>
    )
}

export default AmbarListFilters;